'use client'
import { MatchDetail } from '@/app/libs/match/types'
import { MATCH_DETAIL } from '@/graphql/match/match.query'
import usePolling from '@/shared/hooks/usePolling'
import getStatus from '@/shared/hooks/useStatus'
import { useLazyQuery } from '@apollo/client'
import { useRouter } from 'next/navigation'
import { useRef } from 'react'
import { useMatchContext } from '../matchContext'
import Header from './header'

export default function HeaderWrapper({ data, slug }: { data: MatchDetail; slug: string[] }) {
  const { setMatchDetail, matchDetail } = useMatchContext()
  const { sLiveGameStatusStr } = getStatus(data)
  const statusRef = useRef(sLiveGameStatusStr)
  const [getMatchData] = useLazyQuery(MATCH_DETAIL, {
    fetchPolicy: 'no-cache',
    variables: { input: { _id: data?.oSeo?.iId } }
  })
  const router = useRouter()
  usePolling(
    () => {
      if (matchDetail?._id) {
        getMatchData().then(({ data }) => {
          if (data?.getMatchById) {
            setMatchDetail(data?.getMatchById)
            const currentStatus = getStatus(data?.getMatchById)?.sLiveGameStatusStr

            if (currentStatus !== statusRef.current && currentStatus) {
              router.refresh()
            }
          }
        })
      }
    },
    {
      deps: [data?.oStatus?.sValue],
      interval: 5000,
      skip:
        data?.oStatus?.sValue === 'completed' ||
        data?.oStatus?.sValue === 'cancelled' ||
        !data._id ||
        !matchDetail?._id
    }
  )

  return <Header slug={slug} data={matchDetail} />
}
